<template>
  <div class="member_wrap">
    <Header></Header>
    <div class="wrap_border">
      <van-row style="margin-top: 25px; align-items: center; display: flex">
        <van-col span="10" style="text-align: center; position: relative">
          <!-- TODO add function to change profile picture -->
          <van-uploader :after-read="uploadUserImage" :multiple="false">
            <img class="userImg" :src="data.user_icon" />
            <img class="editImage" src="../images/member/edit.png" />
          </van-uploader>
        </van-col>
        <van-col span="14">
          <van-row
            ><p style="font-size: 32px; font-weight: 700">
              {{ data.name }}
            </p></van-row
          >
          <van-row
            ><p style="padding: 15px 0px 0px 3px">
              {{ $t("member.userId") }}: {{ data.uid }}
            </p></van-row
          >
          <van-row style="padding-top: 15px">
            <div class="VIPlevel">
              <img height="20px" src="../images/member/Diamond.png" />
              <p style="padding-left: 6px; font-size: 12px">
                {{ data.level_name }}
              </p>
            </div>
          </van-row>
          <!-- <van-row style="padding-top: 10px">
            <div class="userVerify">
              <img height="20" src="../images/member/greenTick.png" />
              <p class="verifyText">Verified</p>
            </div>
          </van-row> -->
        </van-col>
      </van-row>
      <van-row>
        <van-col span="24">
          <router-link to="/fundingdetails">
            <p class="balance">
              {{ $t("member.balance") }}: {{ data.money }}USDT
              <img class="moreImage" src="../images/member/more.png" />
            </p>
          </router-link>
        </van-col>
      </van-row>
      <!-- ------------ recharge and withdraw------------- -->
      <van-row style="padding-top: 20px">
        <van-col span="12" style="border-right: 1px solid #969799">
          <div
            style="align-items: center; display: flex; justify-content: center"
            @click="rechargeTypes()"
          >
            <img src="../images/member/Recharge.png" style="width: 30px" />
            <p class="rechargeText">{{ $t("member.recharge") }}</p>
          </div>
        </van-col>
        <van-col span="12">
          <div
            style="align-items: center; display: flex; justify-content: center"
            @click="withdrawList()"
          >
            <img src="../images/member/Withdraw.png" style="width: 30px" />
            <p class="withdrawText">{{ $t("member.withdraw") }}</p>
          </div>
        </van-col>
      </van-row>
      <van-row class="detailBox">
        <!-- <-- --------- name ------ -->
        <van-row style="padding-top: 10px">
          <van-col span="10">
            <p class="detailList">{{ $t("member.fullName") }}:</p>
          </van-col>
          <van-col span="14">
            <p class="detailInfo">{{ data.name }}</p>
          </van-col>
        </van-row>
        <!-- --------- country ------ -->
        <!-- TODO set the country of the user -->
        <!-- <van-row style="padding-top: 25px; display: flex; align-items: center">
          <van-col span="10">
            <p class="detailList">{{ $t("member.country") }}:</p>
          </van-col>
          <van-col span="14">
            <img
              style="width: 40px; padding-left: 10px"
              src="../images/member/flag.png"
            />
          </van-col>
        </van-row> -->
        <!-- --------- language ------ -->
        <van-row style="padding-top: 25px">
          <van-col span="10">
            <p class="detailList">{{ $t("member.language") }}:</p>
          </van-col>
          <van-col span="14">
            <router-link to="/language">
              <p class="detailInfo">{{ $t("lang.name") }}</p>
            </router-link>
          </van-col>
        </van-row>
        <!-- --------- investment ------ -->
        <van-row style="padding-top: 28px">
          <van-col span="10">
            <p class="detailList">{{ $t("member.totalInvestment") }}:</p>
          </van-col>
          <van-col span="14">
            <p class="detailInfo">${{ data.totalinvest }}</p>
          </van-col>
        </van-row>
        <!-- --------- tl number ------ -->
        <van-row style="padding-top: 28px">
          <van-col span="10">
            <p class="detailList">{{ $t("member.mobile") }}:</p>
          </van-col>
          <van-col span="14">
            <p class="detailInfo">{{ data.mobile }}</p>
          </van-col>
        </van-row>
        <!-- --------- email ------ -->
        <!-- TODO -->
        <!-- <van-row style="padding-top: 28px">
          <van-col span="10">
            <p class="detailList">{{ $t("member.email") }}:</p>
          </van-col>
          <van-col span="14">
            <p class="detailInfo">{{data.email}}</p>
          </van-col>
        </van-row> -->
      </van-row>
      <van-row style="padding-top: 25px">
        <van-col span="24">
          <router-link to="/settings">
            <div class="settingsBg">
              <p class="settingText">{{ $t("member.setting") }}</p>
            </div>
          </router-link>
        </van-col>
      </van-row>

      <!-- ============================ RECHARGE ========================
      ================================================================= -->

      <!-- =============== click recharge show channel popup ====== -->
      <van-popup
        v-model="rechargeChannels"
        round
        :style="{ width: '90%' }"
        @closed="rechargeAmount = 0"
      >
        <div style="padding: 30px 10px 20px">
          <p class="channelTopic" style="padding-bottom: 15px">
            {{ $t("member.channelTopic") }}
          </p>
          <!-- ---------- Recharge types --------->

          <van-radio-group v-model="selectedRechargeTypeIndex">
            <van-cell-group>
              <van-cell
                v-for="(rechargeType, index) in rechargeTypesList"
                :key="rechargeType.id"
                :title="rechargeType[lang]"
                clickable
                @click="selectedRechargeTypeIndex = index"
              >
                <template #right-icon>
                  <van-radio :name="index" />
                </template>
              </van-cell>
            </van-cell-group>
          </van-radio-group>
          <!-- <van-row
            style="padding: 20px; display: flex; align-items: center"
            @click="rechargeWalletInfoPopup()"
          >
            <van-col span="16">
              <span class="Wallet">{{ $t("member.cryptoWallet") }}</span>
            </van-col>
            <van-col span="8" style="text-align: right">
              <van-icon name="arrow" class="linkIcon" />
            </van-col>
          </van-row> -->
          <!-- ---------- channel list  (recharge)------- -->
          <!-- <van-row style="overflow-y: scroll; max-height: 200px">
            <van-row class="channelList">
              <van-col span="16">
                <span>America</span>
              </van-col>
              <van-col span="8" style="text-align: right">
                <div style="font-size: 20px">A</div>
              </van-col>
            </van-row>
            <van-row class="channelListActive">
              <van-col span="16">
                <span>British</span>
              </van-col>
              <van-col span="8" style="text-align: right">
                <div style="font-size: 20px">B</div>
              </van-col>
            </van-row>
          </van-row> -->
          <van-row class="amountRow">
            <van-col span="12"
              ><span class="amountText">{{
                $t("member.Amount")
              }}</span></van-col
            >
            <van-col span="12" style="text-align: right">
              <van-field
                v-model="rechargeAmount"
                type="number"
                class="investAmount"
              />
            </van-col>
          </van-row>
          <van-row style="padding-top: 20px">
            <van-col span="12">
              <div
                class="btnCancelBg"
                @click="
                  rechargeChannels = false;
                  rechargeAmount = 0;
                  selectedRechargeTypeIndex = 0;
                "
              >
                <p class="cancelBtnText">{{ $t("member.cancel") }}</p>
              </div>
            </van-col>
            <van-col span="12">
              <div class="btnConfirmBg" @click="confirmRecharge">
                <p class="okBtnText">{{ $t("member.confirm") }}</p>
              </div>
            </van-col>
          </van-row>
        </div>
      </van-popup>
      <!-- =============== show wallet detail popup ====== -->
      <van-popup
        v-model="rechargeWallet"
        round
        :style="{ width: '90%' }"
        @closed="clearValuesRecharge()"
      >
        <div style="padding: 30px 15px 20px">
          <p class="channelTopic">{{ $t("member.cryptoWallet") }}</p>
          <van-row v-if="rechargeWallet">
            <van-col span="24" style="text-align: center">
              <img
                :src="rechargeTypesList[selectedRechargeTypeIndex].crypto_image"
                style="height: 100px; width: auto; margin-top: 20px"
              />
            </van-col>
          </van-row>
          <van-row v-if="rechargeWallet" class="addressBg">
            <p style="font-size: 14px; color: #646566">
              {{ $t("member.walletAddress") }}
            </p>
            <p class="walletAddress">
              {{ rechargeTypesList[selectedRechargeTypeIndex].crypto_link }}
            </p>
          </van-row>
          <van-row style="padding-top: 25px">
            <van-col span="24" @click="copyWalletAddress()">
              <div class="btnCopyBg">
                <p class="copyText">{{ $t("member.copyWallet") }}</p>
              </div>
            </van-col>
          </van-row>
        </div>
      </van-popup>

      <!-- show bank card details popup -->
      <van-popup
        v-model="bankRecharge"
        round
        :style="{ width: '90%' }"
        @closed="clearValuesRecharge()"
      >
        <div style="padding: 30px 15px 30px">
          <p class="channelTopic" style="padding-bottom: 15px">
            {{ $t("member.bankCard") }}
          </p>

          <!-- ----- first name ----- -->
          <van-row v-if="bankRecharge" class="bankDetailRow">
            <van-col span="12"
              ><span class="bankLeftText">{{
                $t("member.bankBranchName")
              }}</span></van-col
            >
            <van-col span="12" style="text-align: right">
              <p class="withdrawDetailText">
                {{ rechargeTypesList[selectedRechargeTypeIndex].bank }}
              </p>
            </van-col>
          </van-row>
          <!-- ----- family name ----- -->
          <van-row v-if="bankRecharge" class="bankDetailRow">
            <van-col span="12"
              ><span class="bankLeftText">{{
                $t("member.bankAccount")
              }}</span></van-col
            >
            <van-col span="12" style="text-align: right">
              <p class="withdrawDetailText">
                {{ rechargeTypesList[selectedRechargeTypeIndex].bank_name }}
              </p>
            </van-col>
          </van-row>
          <!-- ----- bank card ----- -->
          <van-row v-if="bankRecharge" class="bankDetailRow">
            <van-col span="12"
              ><span class="bankLeftText">{{
                $t("member.bankName")
              }}</span></van-col
            >
            <van-col span="12" style="text-align: right">
              <p class="withdrawDetailText">
                {{ rechargeTypesList[selectedRechargeTypeIndex].bank_account }}
              </p>
            </van-col>
          </van-row>

          <!-- ------- confirm button ------- -->
          <van-row style="padding-top: 20px">
            <van-col span="24">
              <div class="btnConfirmBg" @click="bankRecharge = false">
                <p class="okBtnText">{{ $t("member.confirm") }}</p>
              </div>
            </van-col>
          </van-row>
        </div>
      </van-popup>

      <!-- ============================ WITHDRAW =========================
      ================================================================= -->

      <!-- =============== click withdraw show withdraw types popup ====== -->
      <van-popup v-model="withdrawTypes" round :style="{ width: '90%' }">
        <div style="padding: 30px 15px 20px">
          <p class="channelTopic" style="padding-bottom: 15px">
            {{ $t("member.withdrawTo") }}
          </p>
          <!-- ---------- crypto wallet ------- -->
          <van-row
            style="padding: 20px 10px 10px; display: flex; align-items: center"
            @click="withdrawWalletInfoPopup()"
          >
            <van-col span="16">
              <span class="Wallet">{{ $t("member.myCryptoWallet") }}</span>
            </van-col>
            <van-col span="8" style="text-align: right">
              <van-icon name="arrow" class="linkIcon" />
            </van-col>
          </van-row>
          <!-- ---------- bank card ------- -->
          <van-row
            style="padding: 20px 10px 10px; display: flex; align-items: center"
            @click="withdrawBankInfoPopup()"
          >
            <van-col span="16">
              <span class="Wallet">{{ $t("member.myBankCard") }}</span>
            </van-col>
            <van-col span="8" style="text-align: right">
              <van-icon name="arrow" class="linkIcon" />
            </van-col>
          </van-row>
        </div>
      </van-popup>
      <!-- =============== withdraw by wallet popup ====== -->
      <van-popup
        v-model="walletWithdraw"
        round
        :style="{ width: '90%' }"
        @closed="clearValuesWallet()"
      >
        <div style="padding: 30px 15px 30px">
          <p class="channelTopic">{{ $t("member.myCryptoWallet") }}</p>
          <van-row class="addressBg">
            <p style="font-size: 14px; color: #646566">
              {{ $t("member.walletAddress") }}
            </p>
            <p class="walletAddress">{{ withdrawChannelDetails.wid }}</p>
          </van-row>
          <van-row class="amountRow">
            <van-col span="12"
              ><span class="amountText">{{
                $t("member.Amount")
              }}</span></van-col
            >
            <van-col span="12" style="text-align: right">
              <van-field
                v-model="withdrawAmount"
                type="number"
                class="investAmount"
              />
            </van-col>
          </van-row>
          <van-row class="amountRow">
            <van-col span="12"
              ><span class="amountText">{{
                $t("settings.withdrawalPassword")
              }}</span></van-col
            >
            <van-col span="12" style="text-align: right">
              <van-field
                v-model="withdrawPassword"
                type="password"
                class="investAmount"
              />
            </van-col>
          </van-row>
          <van-row style="padding-top: 20px">
            <van-col span="12">
              <div class="btnCancelBg" @click="walletWithdraw = false">
                <p class="cancelBtnText">{{ $t("member.cancel") }}</p>
              </div>
            </van-col>
            <van-col span="12">
              <div class="btnConfirmBg" @click="withdrawViaWalletAddress">
                <p class="okBtnText">{{ $t("member.confirm") }}</p>
              </div>
            </van-col>
          </van-row>
        </div>
      </van-popup>
      <!-- =============== withdraw by bankcard popup ====== -->
      <van-popup
        v-model="bankWithdraw"
        round
        :style="{ width: '90%' }"
        @closed="clearValuesBank()"
      >
        <div style="padding: 30px 15px 30px">
          <p class="channelTopic" style="padding-bottom: 15px">
            {{ $t("member.myBankCard") }}
          </p>
          <!-- ---- amount ---- -->
          <van-row class="bankDetailRow">
            <van-col span="12"
              ><span class="bankLeftText">{{
                $t("member.Amount")
              }}</span></van-col
            >
            <van-col span="12" style="text-align: right">
              <van-field
                v-model="withdrawAmount"
                type="number"
                class="investAmount"
              />
            </van-col>
          </van-row>
          <!-- ----- first name ----- -->
          <van-row class="bankDetailRow">
            <van-col span="12"
              ><span class="bankLeftText">{{
                $t("member.bankFirstName")
              }}</span></van-col
            >
            <van-col span="12" style="text-align: right">
              <p class="withdrawDetailText">
                {{ withdrawChannelDetails.name }}
              </p>
            </van-col>
          </van-row>
          <!-- ----- family name ----- -->
          <van-row class="bankDetailRow">
            <van-col span="12"
              ><span class="bankLeftText">{{
                $t("member.bankFamilyName")
              }}</span></van-col
            >
            <van-col span="12" style="text-align: right">
              <p class="withdrawDetailText">
                {{ withdrawChannelDetails.name }}
              </p>
            </van-col>
          </van-row>
          <!-- ----- bank card ----- -->
          <van-row class="bankDetailRow">
            <van-col span="12"
              ><span class="bankLeftText">{{
                $t("member.bankCard")
              }}</span></van-col
            >
            <van-col span="12" style="text-align: right">
              <p class="withdrawDetailText">
                {{ withdrawChannelDetails.account }}
              </p>
            </van-col>
          </van-row>
          <!-- ----- bank branch name ----- -->
          <van-row class="bankDetailRow">
            <van-col span="12"
              ><span class="bankLeftText">{{
                $t("member.bankBranchName")
              }}</span></van-col
            >
            <van-col span="12" style="text-align: right">
              <p class="withdrawDetailText">
                {{ withdrawChannelDetails.area }}
              </p>
            </van-col>
          </van-row>
          <!-- ----- bank withdraw password ----- -->
          <van-row class="bankDetailRow">
            <van-col span="12"
              ><span class="bankLeftText">{{
                $t("settings.withdrawalPassword")
              }}</span></van-col
            >
            <van-col span="12" style="text-align: right">
              <van-field
                v-model="withdrawPassword"
                type="password"
                class="investAmount"
              />
            </van-col>
          </van-row>
          <!-- ------- cancel, confirm buttons ------- -->
          <van-row style="padding-top: 20px">
            <van-col span="12">
              <div class="btnCancelBg" @click="bankWithdraw = false">
                <p class="cancelBtnText">{{ $t("member.cancel") }}</p>
              </div>
            </van-col>
            <van-col span="12">
              <div
                class="btnConfirmBg"
                :class="
                  withdrawPassword != '' && withdrawAmount != ''
                    ? ''
                    : 'no_touch'
                "
                @click="withdrawViaBankCard"
              >
                <p class="okBtnText">{{ $t("member.confirm") }}</p>
              </div>
            </van-col>
          </van-row>
        </div>
      </van-popup>
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Vue from "vue";
import qs from "qs";
import Fetch from "../../utils/fetch";
import Header from "../../components/header";
import Footer from "../../components/footer";
import { Browser } from "@capacitor/browser";
import { Clipboard } from "@capacitor/clipboard";
import {
  Icon,
  Col,
  Row,
  Popup,
  Field,
  Uploader,
  Radio,
  RadioGroup,
  Cell,
  CellGroup,
  Dialog,
} from "vant";

Vue.use(Icon)
  .use(Row)
  .use(Col)
  .use(Popup)
  .use(Field)
  .use(Uploader)
  .use(Radio)
  .use(RadioGroup)
  .use(Cell)
  .use(CellGroup)
  .use(Dialog);

export default {
  name: "member",
  components: {
    Footer,
    Header,
  },
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      data: {},
      rechargeChannels: false,
      rechargeWallet: false,
      withdrawTypes: false,
      walletWithdraw: false,
      bankWithdraw: false,
      bankRecharge: false,
      withdrawAmount: "",
      rechargeAmount: 0,
      withdrawPassword: "",
      rechargeTypesList: [],
      selectedRechargeTypeIndex: 0,
      withdrawChannelDetails: {},
    };
  },
  created() {
    // this.$parent.footer("member");
  },
  mounted() {
    this.start();
  },
  methods: {
    start() {
      Fetch("/user/info").then((r) => {
        this.data = r.data;
      });
    },
    // recharge
    rechargeWalletInfoPopup() {
      this.rechargeChannels = false;
      this.rechargeWallet = true;
    },
    // show withdraw types
    withdrawList() {
      this.withdrawTypes = true;
    },
    // show wallet withdraw
    withdrawWalletInfoPopup() {
      this.withdrawTypes = false;

      if (this.data.wallet_has) {
        Fetch("/finance/user_bank_list", {
          type: 2,
        }).then((r) => {
          this.walletWithdraw = true;
          this.withdrawChannelDetails = r.data;
        });
      } else {
        this.$router.push({
          path: "/setwallet",
        });
      }
    },

    // show bank withdraw
    withdrawBankInfoPopup() {
      this.withdrawTypes = false;

      if (this.data.bank_has) {
        Fetch("/finance/user_bank_list", {
          type: 1,
        }).then((r) => {
          this.bankWithdraw = true;
          this.withdrawChannelDetails = r.data;
        });
      } else {
        this.$router.push({
          path: "/setbankcard",
        });
      }
    },
    uploadUserImage(selectedFile) {
      Fetch(
        "/uploads/avatar_uploads",
        { file: selectedFile.file },
        {},
        true,
        true
      ).then((r) => {
        if (r.code === 1) this.start();
      });
    },
    withdrawViaWalletAddress() {
      if (!this.data.withdraw_pass_set) {
        Dialog.confirm({
          cancelButtonText: this.$t("confirmDialog.cancel"),
          confirmButtonText: this.$t("confirmDialog.confirm"),
          message: this.$t("confirmDialog.content"),
        })
          .then(() => {
            this.$router.push({
              path: "/setpaypwd",
            });
          })
          .catch(() => {});
        return;
      }
      if (
        this.withdrawAmount == 0 ||
        this.withdrawPassword === "" ||
        this.withdrawChannelDetails.wid === ""
      )
        return;
      Fetch("/finance/withdraw", {
        withdraw_amount: this.withdrawAmount,
        withdraw_pw: this.withdrawPassword,
        wallet_address: this.withdrawChannelDetails.wid,
        withdraw_type: 2,
      }).then((r) => {
        this.walletWithdraw = false;
        this.$toast.success();
      });
    },
    withdrawViaBankCard() {
      if (!this.data.withdraw_pass_set) {
        Dialog.confirm({
          cancelButtonText: this.$t("confirmDialog.cancel"),
          confirmButtonText: this.$t("confirmDialog.confirm"),
          message: this.$t("confirmDialog.content"),
        })
          .then(() => {
            this.$router.push({
              path: "/setpaypwd",
            });
          })
          .catch(() => {});
        return;
      }
      if (
        this.withdrawAmount == 0 ||
        this.withdrawPassword === "" ||
        this.withdrawChannelDetails.account === ""
      )
        return;
      Fetch("/finance/withdraw", {
        withdraw_amount: this.withdrawAmount,
        withdraw_pw: this.withdrawPassword,
        bank_account: this.withdrawChannelDetails.account,
        withdraw_type: 1,
      }).then((r) => {
        this.bankWithdraw = false;
        this.$toast.success();
      });
    },

    rechargeTypes() {
      Fetch("/finance/recharge_type").then((r) => {
        this.rechargeTypesList = r.data;
        this.rechargeChannels = true;
      });
    },
    confirmRecharge() {
      if (
        this.rechargeTypesList[this.selectedRechargeTypeIndex].type == 1 &&
        this.data.wallet_has == 0
      ) {
        Dialog.confirm({
          cancelButtonText: this.$t("confirmDialog.cancel"),
          confirmButtonText: this.$t("confirmDialog.confirm"),
          message: this.$t("confirmDialog.bindWallet"),
        })
          .then(() => {
            this.$router.push({
              path: "/setwallet",
            });
          })
          .catch(() => {});
        return;
      }

      if (this.rechargeAmount == 0 || this.rechargeAmount === "") return;

      Fetch("/finance/recharge", {
        recharge_type_id:
          this.rechargeTypesList[this.selectedRechargeTypeIndex].id,
        recharge_amount: this.rechargeAmount,
      }).then((r) => {
        if (r.code == 1) {
          this.rechargeChannels = false;
          switch (
            this.rechargeTypesList[this.selectedRechargeTypeIndex].view_type
          ) {
            case 1:
              this.rechargeWallet = true;
              break;
            case 2:
              this.bankRecharge = true;
              break;
            case 3:
              if (Capacitor.getPlatform() === "android") {
                Browser.open({ url: r.data });
              } else {
                window.open(r.data);
              }
              this.selectedRechargeTypeIndex = 0;

              break;
            default:
              this.selectedRechargeTypeIndex = 0;
              this.$toast(this.$t("member.rechargeFail"));
              break;
          }
        }
      });
    },
    clearValuesWallet() {
      (this.withdrawAmount = 0), (this.withdrawPassword = "");
    },
    clearValuesBank() {
      (this.withdrawAmount = 0), (this.withdrawPassword = "");
    },
    clearValuesRecharge() {
      this.rechargeAmount = 0;
      this.selectedRechargeTypeIndex = 0;
    },
    copyWalletAddress() {
      this.rechargeWallet = false;
      Clipboard.write({
        string:
          this.rechargeTypesList[this.selectedRechargeTypeIndex].crypto_link,
      });
    },
  },
};
</script>

<style scoped>
.member_wrap {
  background: url(../images/member/backBg.png);
  /* background-size: 100% 100%; */
  background-size: cover;
  height: 100vh;
  margin-bottom: -45px;
}

.wrap_border {
  border: 1px solid #ffffff;
  border-radius: 13px;
  padding: 15px 10px 80px;
  margin: 15px;
  background: #ebebeb66;
}

.userImg {
  height: 115px;
  width: 115px;
  border-radius: 50%;
}

.VIPlevel {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  width: fit-content;
  text-align: center;
  background-color: #ffffff;
  padding: 5px 10px;
}

.userVerify {
  display: flex;
  line-height: 20px;
}

.verifyText {
  font-size: 12px;
  background: #ffd01e;
  padding: 0px 12px;
  border-radius: 15px;
  color: #0e9c52;
  margin-left: 5px;
  font-weight: 700;
}

.detailBox {
  box-shadow: rgb(0 0 0 / 24%) 0px 3px 8px;
  border: 1px solid #ffffff;
  border-radius: 13px;
  padding: 15px;
  background: #ebebeb66;
  margin-top: 25px;
}

.detailList {
  font-size: 17px;
  color: #616265;
  word-break: break-word;
}

.detailInfo {
  font-size: 17px;
  color: #000000;
  padding-left: 10px;
  word-break: break-word;
}

.editImage {
  position: absolute;
  bottom: 0px;
  right: 5px;
  width: 35px;
}

.balance {
  color: #ff9100;
  font-size: 14px;
  text-align: center;
  padding: 8px;
  background: #fff5e9;
  margin-top: 15px;
  border: 1px solid #ff9100;
  border-radius: 3px;
  position: relative;
}

.moreImage {
  height: 14px;
  position: absolute;
  top: 8px;
  right: 8px;
}

.settingsBg {
  background: url(../images/member/settingBg.png);
  background-size: 100% 100%;
}

.settingText {
  color: #000000;
  font-size: 22px;
  text-align: center;
  padding: 12px 0px;
}

.rechargeText {
  font-size: 18px;
  color: #ff9100;
  padding-left: 6px;
}

.withdrawText {
  font-size: 18px;
  color: #ff0000;
  padding-left: 6px;
}

.channelTopic {
  color: #000000;
  font-size: 18px;
  text-align: center;
  font-weight: 700;
}

.Wallet {
  font-size: 17px;
  color: #000000;
  /* font-weight: 700; */
}

.linkIcon {
  color: #000000;
  font-size: 18px;
}

.channelList {
  background: #f1f6f6;
  margin: 0px 10px 10px;
  color: #000000;
  font-size: 17px;
  padding: 10px;
}

.channelListActive {
  margin: 0px 10px 10px;
  background: #f1f6f6;
  padding: 10px;
  font-size: 17px;
  color: #ff9920;
}

.addressBg {
  background: linear-gradient(
    180deg,
    rgba(255, 215, 0, 0.13) 0%,
    rgba(255, 145, 0, 0.13) 100%
  );
  border: 1px solid #ff9920;
  padding: 12px 14px;
  border-radius: 6px;
  margin-top: 20px;
}

.btnCopyBg {
  background: linear-gradient(180deg, #ffd700 0%, #ff9100 100%);
  border-radius: 6px;
}

.copyText {
  color: #ffffff;
  font-size: 22px;
  text-align: center;
  padding: 12px 0px;
}

.walletAddress {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 18px;
  padding-top: 10px;
}

.amountRow {
  align-items: center;
  display: flex;
  padding: 12px 14px;
  margin-top: 10px;
}

.amountText {
  color: #000000;
  font-size: 18px;
  font-weight: 700;
  word-break: break-word;
}

.investAmount {
  padding: 0 !important;
}

.btnCancelBg {
  border: 1px solid #ff9100;
  border-radius: 6px;
  margin-right: 5px;
}

.btnConfirmBg {
  background: linear-gradient(180deg, #ffd700 0%, #ff9100 100%);
  border-radius: 6px;
  margin-left: 5px;
  border: 1px solid #ffd700;
}

.cancelBtnText {
  color: #ff9100;
  font-size: 20px;
  text-align: center;
  padding: 8px 0px;
}

.okBtnText {
  color: #ffffff;
  font-size: 20px;
  text-align: center;
  padding: 8px 0px;
}

.bankDetailRow {
  align-items: center;
  display: flex;
  padding: 10px 10px;
}

.bankLeftText {
  color: #000000;
  font-size: 16px;
  white-space: nowrap;
}
.withdrawDetailText {
  color: #999999;
  font-size: 18px;
  text-align: right;
}
.no_touch {
  pointer-events: none;
}
</style>
<style>
.investAmount .van-field__control {
  color: #999999;
  font-size: 18px;
  text-align: right;
}
</style>
